// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"177":"home","328":"admin","571":"settings","821":"inspection"}[chunkId] || chunkId) + "." + {"177":"4d9c499b","328":"284b05c0","571":"90b888c1","694":"064f6f99","821":"14d977b8"}[chunkId] + ".css";
};